const SuccessLoader = () => {
    return (
        <div className="bg-cover bg-center h-screen flex items-center justify-center" style={{ backgroundImage: `url(${"/loader.png"})` }}>
        </div>
    );
}

export default SuccessLoader;